import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../layout/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import CompImg from "../../assets/svg/comp-img.svg";
import PlayButton from "../../assets/svg/play-button.svg";
import StoreButton from "../../assets/svg/store-button.svg";
import BackArrow from "../../assets/svg/back-arrow.svg";
import Carousel from "react-material-ui-carousel";
import CompBgImg from "../../assets/svg/comp-slide-bg.svg";
import { Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
const ComprehensiveInsuranceManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [isloading, setIsloading] = useState(false)
  const checkScrollPosition = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      console.log("scrollLeft", scrollLeft);
      setIsStart(scrollLeft === 130);
      setIsEnd(scrollLeft + clientWidth >= scrollWidth);
    }
  };

  const scroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      containerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      checkScrollPosition();
      container.addEventListener("scroll", checkScrollPosition);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", checkScrollPosition);
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <div className="p-[16px] sm:p-[30px]">
        <div className="sm:hidden flex items-center justify-between w-[100%]">
          {/* <div
            className="w-[32%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.HOSPICASH
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.HOSPICASH);
            }}
          >
            Hospicash Insurance
          </div> */}
          <div
            className="w-[48%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.WELLNESS
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.WELLNESS);
            }}
          >
            Wellness Benefits
          </div>
          <div
            className="w-[48%] h-[60px] rounded-[10px] cursor-pointer text-[9px] leading-[12px] text-white p-[12px] font-bold flex items-center justify-center text-center"
            style={
              location.pathname === ROUTE_PATH.COMPREHENSIVE
                ? { backgroundColor: "#1E56FF", color: "white" }
                : { backgroundColor: "#E6ECFF", color: "#1E56FF" }
            }
            onClick={() => {
              navigate(ROUTE_PATH.COMPREHENSIVE);
            }}
          >
            Coversure Platform
          </div>
        </div>
        <div className="sm:hidden flex items-center w-[100%] text-[16px] leading-[20px] font-semibold mt-[16px] mb-[24px]">
          <img
            src={BackArrow}
            alt="BackArrow"
            className="block lg:hidden relative left-[-5%]"
            onClick={() => navigate(ROUTE_PATH.DASHBOARD)}
          />
          <span className="relative top-[-5px] left-[-5%]">
            Coversure Platform
          </span>
        </div>
        <div>
          <img
            src={CompImg}
            alt="CompImg"
            className="w-[65%] lg:w-[70%] xl:w-[55%] sm:w-[80%] m-auto"
            loading="lazy"
            onLoad={()=>setIsloading(true)}
            style={{ opacity: isloading ? 1 : 0, transition: 'opacity 0.5s ease-in' }}
          />
          <div className="flex items-center justify-center mt-[42px]">
            <img
              src={PlayButton}
              alt="PlayButton"
              className="xl:h-[65px] lg:h-[50px] h-[40px] mr-[5px] sm:mr-[10px] cursor-pointer"
              onClick={() => {
                window.open(
                  "https://coversure.onelink.me/40Yt/i3n6x54p",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            />
            <img
              src={StoreButton}
              alt="StoreButton"
              className="xl:h-[65px] lg:h-[50px] h-[40px] ml-[5px] sm:ml-[10px] cursor-pointer"
              onClick={() => {
                window.open(
                  "https://coversure.onelink.me/40Yt/i3n6x54p",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            />
          </div>
          <div className="block lg:hidden">
            <Carousel height={300}>
              <div className="mt-[51px] ">
                <div className="text-[18px] leading-[22px] tracking-tighter font-bold text-center w-[80%] m-[auto] mb-[20px]">
                  Do you know where your policies are?
                </div>
                <div className="bg-custom-gradient p-[30px] rounded-[25px]">
                  <div className="mb-[20px] ">
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Insurance portfolio
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Get a single view of all your insurance
                    </div>
                  </div>
                  <div>
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Discover hidden insurance
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Find FREE insurance available on your credit/debit cards
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-[51px]">
                <div className="text-[18px] leading-[22px] tracking-tighter font-bold text-center m-[auto] w-[80%] mb-[20px]">
                  Do you know what is covered and not covered in your policy?
                </div>
                <div className="bg-custom-gradient p-[30px] rounded-[25px]">
                  <div className="mb-[20px]">
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Understand the T&C of your policy
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Know the hidden truth of your insurance to ensure 100%
                      coverage
                    </div>
                  </div>
                  <div>
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Ensure you are 100% covered
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Discover the hidden benefits offered with your insurance
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-[51px]">
                <div className="text-[18px] leading-[22px] tracking-tighter font-bold text-center m-[auto] w-[80%] mb-[20px]">
                  Does your family know about your insurance?
                </div>
                <div className="bg-custom-gradient p-[30px] rounded-[25px]">
                  <div className="mb-[20px]">
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Share insurance with family
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Keep your family aware of the insurance you hold so they
                      can use it in uncertain times
                    </div>
                  </div>
                  <div>
                    <div className="text-[14px] leading-[18px] text-white font-bold">
                      Manage family insurance
                    </div>
                    <div className="text-[12px] leading-[18px] text-white">
                      Add family policies to ensure timely renewal and
                      utilisation of benefits offered
                    </div>
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
          <div className="hidden lg:block">
            <Box
              ref={containerRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: 4,
                padding: "10px",
                scrollSnapType: "x mandatory",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              <Box
                className="mt-[51px] xl:ml-[120px] w-[460px] xl:w-[585px]"
                sx={{ flex: "0 0 auto", scrollSnapAlign: "start" }}
              >
                <div className="text-[28px] leading-[30px] xl:text-[33px] xl:leading-[40px] tracking-tighter font-bold text-center w-[100%] xl:w-[80%] m-[auto] mb-[20px]">
                  Do you know where your policies are?
                </div>
                <div className="bg-white p-[30px] rounded-[25px] w-[460px] xl:w-[585px] relative h-[313px]">
                  <img
                    src={CompBgImg}
                    alt="CompBgImg"
                    className="absolute bottom-[0] right-[-1%] w-[190px]"
                  />
                  <div className="mb-[20px] w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Insurance portfolio
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Get a single view of all your insurance
                    </div>
                  </div>
                  <div className="w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Discover hidden insurance
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Find FREE insurance available on your credit/debit cards
                    </div>
                  </div>
                </div>
              </Box>
              <Box
                className="mt-[51px] w-[460px] xl:w-[585px]"
                sx={{ flex: "0 0 auto", scrollSnapAlign: "start" }}
              >
                <div className="text-[28px] leading-[30px] xl:text-[33px] xl:leading-[40px] tracking-tighter font-bold text-center w-[100%] xl:w-[80%] m-[auto] mb-[20px]">
                  Do you know what is covered and not covered in your policy?
                </div>
                <div className="bg-white p-[30px] rounded-[25px] w-[460px] xl:w-[585px] relative h-[313px]">
                  <img
                    src={CompBgImg}
                    alt="CompBgImg"
                    className="absolute bottom-[0] right-[-1%] w-[190px]"
                  />
                  <div className="mb-[20px] w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Understand the T&C of your policy
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Know the hidden truth of your insurance to ensure 100%
                      coverage
                    </div>
                  </div>
                  <div className="w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Ensure you are 100% covered
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Discover the hidden benefits offered with your insurance
                    </div>
                  </div>
                </div>
              </Box>
              <Box
                className="mt-[51px] w-[460px] xl:w-[585px]"
                sx={{ flex: "0 0 auto", scrollSnapAlign: "start" }}
              >
                <div className="text-[28px] leading-[30px] xl:text-[33px] xl:leading-[40px] tracking-tighter font-bold text-center w-[100%] xl:w-[80%] m-[auto] mb-[20px]">
                  Does your family know about your insurance?
                </div>
                <div className="bg-white p-[30px] rounded-[25px] w-[460px] xl:w-[585px] relative h-[313px]">
                  <img
                    src={CompBgImg}
                    alt="CompBgImg"
                    className="absolute bottom-[0] right-[-1%] w-[190px]"
                  />
                  <div className="mb-[20px] w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Share insurance with family
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Keep your family aware of the insurance you hold so they
                      can use it in uncertain times
                    </div>
                  </div>
                  <div className="w-[100%] xl:w-[70%] z-10 relative">
                    <div className="text-[26px] leading-[30px] font-bold">
                      Manage family insurance
                    </div>
                    <div className="text-[16px] leading-[24px] mt-[8px]">
                      Add family policies to ensure timely renewal and
                      utilisation of benefits offered
                    </div>
                  </div>
                </div>
              </Box>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
            >
              <div
                onClick={() => !isStart && scroll("left")}
                style={
                  isStart
                    ? {
                        border: "1px solid #D0D5DD",
                        borderRadius: "50%",
                        padding: "10px",
                        cursor: "pointer",
                      }
                    : {
                        border: "1px solid #1E56FF",
                        borderRadius: "50%",
                        padding: "10px",
                        cursor: "pointer",
                      }
                }
              >
                <KeyboardArrowLeftIcon
                  style={
                    isStart
                      ? { color: "#D0D5DD", fontSize: "30px" }
                      : { color: "#1E56FF", fontSize: "30px" }
                  }
                />
              </div>
              <div
                onClick={() => !isEnd && scroll("right")}
                style={
                  isEnd
                    ? {
                        marginLeft: 18,
                        border: "1px solid #D0D5DD",
                        borderRadius: "50%",
                        padding: "10px",
                        cursor: "pointer",
                      }
                    : {
                        marginLeft: 18,
                        border: "1px solid #1E56FF",
                        borderRadius: "50%",
                        padding: "10px",
                        cursor: "pointer",
                      }
                }
              >
                <KeyboardArrowRightIcon
                  style={
                    isEnd
                      ? { color: "#D0D5DD", fontSize: "30px" }
                      : { color: "#1E56FF", fontSize: "30px" }
                  }
                />
              </div>
            </Box>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ComprehensiveInsuranceManagement;
